import * as React from 'react'

export type IFooterProps = {
  copyright?: string
  confidentiality?: string
  platformName?: string
  platformUrl?: string
  lastUpdate?: string
  contentContact?: string
  contentContactUrl?: string
  technicalContact?: string
  technicalContactUrl?: string
}

const Footer = ({
  copyright,
  confidentiality,
  platformName,
  platformUrl,
  lastUpdate,
  contentContact,
  contentContactUrl,
  technicalContact,
  technicalContactUrl
}: IFooterProps) => {

  return (
    <footer>
      <ul>
        {lastUpdate && 
          <li>Last update: {lastUpdate}</li>        
        }
        {copyright &&
          <li>&copy; {copyright} Chevron Corporation</li>        
        }
        {confidentiality &&
          <li>{confidentiality}</li>        
        }
        {
          platformUrl && platformName &&
          <li>
            Platform: <a href={platformUrl}>{platformName}</a>
          </li>
        }
      </ul>
      <ul>
        {contentContactUrl && contentContact &&
          <li>
            Content contact: <a href={contentContactUrl}>{contentContact}</a>
          </li>
        }
        {technicalContactUrl && technicalContact &&
          <li>
            Technical contact:{' '}
            <a href={technicalContactUrl}>{technicalContact}</a>
          </li>
        }
      </ul>
    </footer>
  )
}

export default Footer
